import React from 'react';
import { Link } from 'react-router-dom';
import { BuiltBrandLockup } from './ui/BuiltBrandLockup';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/[0.06] mt-auto" style={{ backgroundColor: '#0c0c0c' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <Link to="/" className="inline-flex hover:opacity-90 transition-opacity">
              <BuiltBrandLockup heightClass="h-8" />
            </Link>
            <p className="font-display text-sm italic tracking-wide text-gray-500 mt-3">
              The build stays with the car.
            </p>
            <p className="text-gray-600 text-xs mt-2">
              © {year} Tangents LLC. All rights reserved.
            </p>
          </div>

          <a
            href="https://instagram.com/on.tangents"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-gray-400 hover:text-gray-300 transition-colors group"
            aria-label="Visit Tangents LLC on Instagram"
          >
            <img
              src="/tangents-logo.png"
              alt=""
              className="w-9 h-auto opacity-80 group-hover:opacity-100 transition-opacity"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
            <span className="text-sm">Designed & developed by Tangents</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
